<template>
  <div  class="showVersions" :id="`version${pickedVariant}`" @change="changeVersionHandler">
      <div class="select">
        <div id="versionBox">
          <strong>Version:</strong> 
          <select>
            <option  v-for="opt in opts" :value="opt">
                {{ opt }}
            </option>
          </select>
        </div>
        <div>
          <button><a :href="backurlhref" target="_blank">Back Image</a></button>
          <button><a :href="fronturlhref" target="_blank">Front Image</a></button>
          <button><a :href="pdfurlhref" target="_blank">PDF</a></button>
        </div>
      </div>
      <div class="comments">
        <p> <strong>SKU:</strong> {{ productSku }}</p>
        <p> <strong>EAN:</strong> {{ productEAN }}</p>
        <p> <strong>Global Product ID:</strong> {{ productID }}</p>
        <p> <strong>Comments:</strong> {{ versionComments }}</p>
      </div>
      <div class="dates">
        <div class="date_ele"><strong>Created :</strong><p>{{ created }}</p></div>
        <div class="date_ele"><strong>Updated :</strong><p>{{ updated }}</p></div>
      </div>
  </div>
</template>

<script>
  import { versionData } from '../productapi'
  export default {
    props: [
      "pickedVariant",
      "pickedProduct",
      "updateVersion",
      "prices"
    ],
    data() {
      return {
        opts:[],
        newVersion:[] ,
        versionComments:"",
        productSku:"",
        productEAN:"",
        productID:"",
        backurlhref:"",
        fronturlhref:"",
        pdfurlhref:"",
        created:"",
        updated:"",
      };
    },
    mounted() {
      this.oldVersion();
    },
    watch: {
      pickedProduct: {
        handler() {
          this.oldVersion();
        }
      }
    },
    methods: {
      changeVersionHandler: function(e) {
        if(this.pickedProduct){
          this.productSku = this.pickedProduct.sku_no;
        }else{
          this.productSku = this.prices.sku_no;
           const event = new CustomEvent('triggerSku', {detail:{ sku1: this.productSku, trigger: true, src: this.prices.imageUrl, version: versionno, oldVersion:old_version}});
          if(versionno){
            event.detail.oldVersion = true;
            event.detail.version = versionno;
            window.dispatchEvent(event);
          }else{
            event.detail.oldVersion = false;
            window.dispatchEvent(event);
          }
          versionData(event.detail.sku1)
          .then((res)=>{ 
            this.productEAN = res.productVersionDetails.ean;
            this.productID = res.productVersionDetails.globalProductName;
            res.productVersionDetails.versiondata.map((v)=> {
              if(versionno == v.versionno) {
                this.versionComments = v.comment? v.comment : "No comment",
                this.created = v.created_at? v.created_at.split(" ")[0] : "No data";
                this.updated = v.updated_at? v.updated_at.split(" ")[0] : "No data";
              }
            });
          })
          .catch(error=>error);
        }
        const version = e.target.value;
        this.newVersion.productVersionDetails.versiondata.map((v) =>{
           if(v.versionno == version){
            this.versionComments = v.comment? v.comment : "No comment",
            this.created = v.created_at? v.created_at.split(" ")[0] : "No data";
            this.updated = v.updated_at? v.updated_at.split(" ")[0] : "No data";
           }
        })
        this.backurlhref = `${window.basedir}/productImageServlet/BACK${this.productSku}.webp/${version}`;
        this.fronturlhref = `${window.basedir}/productImageServlet/FRONT${this.productSku}.webp/${version}`;
        this.pdfurlhref = this.versionUrl(version);
        var old_version = false;
        var  versionno=e.target.value || "";
      },
      oldVersion:  function() {
        var sku ;
        if(this.pickedProduct){
          this.productSku = this.pickedProduct.sku_no;
        }else{
          this.productSku = this.prices.sku_no;
        }
        this.opts = [];
        versionData(this.productSku)
        .then((res)=>{ 
            this.productEAN = res.productVersionDetails.ean;
            this.productID = res.productVersionDetails.globalProductName;
            this.newVersion = res;
            this.newVersion.productVersionDetails.versiondata.map((v) => {
            //this.opts.push(v.versionno);
           // this.versionComments = v.comment? v.comment : "No comment",
           // this.created = v.created_at? v.created_at.split(" ")[0] : "No data";
          // this.updated = v.updated_at?  v.updated_at.split(" ")[0] : "No data";
            if(v.updated_at && v.active !== "Ny"){ 
            this.opts.push(v.versionno);
            this.versionComments = v.comment? v.comment : "No comment",
            this.created = v.created_at? v.created_at.split(" ")[0] : "No data";
            this.updated = v.updated_at?  v.updated_at.split(" ")[0] : "No data";
            }
          });
          this.opts.reverse();
          const version = this.opts[0];
          this.backurlhref = `${window.basedir}/productImageServlet/BACK${this.productSku}.webp/${version}`;
          this.fronturlhref = `${window.basedir}/productImageServlet/FRONT${this.productSku}.webp/${version}`;
          this.pdfurlhref = this.versionUrl(version);
        })
        .catch(error=>console.log("error here",error))
      },
      versionUrl: function(version){
        const flap = this.newVersion.productVersionDetails.flap.split('-')[0];
        const pdfUrl = this.newVersion.productVersionDetails.url.split('/').slice(0,-1).join('/');
        const hrefUrl =pdfUrl + "/" + flap +"-" + version + "." + "pdf";
        return hrefUrl;
      },
    },
    computed:{
      
    }
  };
</script>

<style lang="scss" scoped>
  .showVersions{
    width: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background-color: #7caf63;
    border: 1px solid #7caf63;
    border-radius: 10px;
    margin-bottom: 5px;
    padding: 5px 20px;
    .select{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: baseline;
      #versionBox{
        display: flex;
      }
      select{
        text-decoration: none;
        border:1px solid #7caf63;
        border-radius: 6px;
        width:60px;
        margin-left: 10px; 
      }
      button{
       margin-left: 35px;
        text-decoration: none;
        border: 1px solid #7caf63;
        border-radius: 4px;
        &:hover{
         background-color: #13358a;
          a{
            color:snow;
          }
        }
        a{
          color:black;
        }
      }
    }
    .comments{
      display: flex;
      flex-direction: column;
      margin-left: -5px;
      padding: 5px; 
      p{
        margin-bottom: 2px !important;
      }
    }
    .dates{
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      .date_ele{
        display: flex;
        p{
          margin-left: 5px;
        }
      }
    }
  }
</style>

